/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItemPromoCode_user$ref = any;
export type CartItemTitle_user$ref = any;
export type CartItemTitle_user = {
    readonly " $fragmentRefs": CartItemPromoCode_user$ref;
    readonly " $refType": CartItemTitle_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItemTitle_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "CartItemPromoCode_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'f669384126c53b0d3b4889ea84ea98aa';
export default node;
